import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProvince(params) {
	return client.get("public/option/list_province", {
		params: params,
	});
}
function getCity(params) {
	return client.get("public/option/list_city", {
		params: params,
	});
}
function getSubdistrict(params) {
	return client.get("public/option/list_subdistrict", {
		params: params,
	});
}
function getBank(params) {
	return client.get("general/bank", {
		params: params,
	});
}
function getUplineData(params) {
	return client.get("general/checkupline", {
		params: params,
	});
}

function getBankCompany(params) {
	return client.get("general/bank-company", {
		params: params,
	});
}


function getCountries(params) {
	return client.get("/general/country/public/option/list_country", {
		params: params,
	});
}

export default {
	getProvince,
	getCity,
	getSubdistrict,
	getBank,
	getUplineData,
	getBankCompany,
	getCountries
};